const disablePageScaling = () => {
  const metaViewport = document.querySelector('meta[name="viewport"]');
  metaViewport?.setAttribute(
    'content',
    'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
  );
};

export default disablePageScaling;
